import React from 'react'
import { renderToString } from 'react-dom/server'
import { Provider } from 'react-redux'
import { ThemeProvider, ServerStyleSheet } from 'styled-components'
import { StickyContainer } from 'react-sticky'

import { MediaQueryProvider } from 'contexts/MediaQueryContext'

import { isTouchDevice } from '../../components/utils/displayUtils'
import TouchDeviceContext from '../../contexts/TouchDeviceContext'
import GlobalStyle from '../../styles/GlobalStyles'

import Notifier from '../../components/Notifier'
import AuthModal from '../../components/auth/AuthModal'

import styledTheme from '../../styles/theme'
import configureStore from '../../typedRedux/configureStoreWithHistory'

const { store } = configureStore()

class StaticWrapper extends React.Component {
  renderProvidedComponent = () => {
    const { isPage, children } = this.props
    return (
      <TouchDeviceContext.Provider value={isTouchDevice()}>
        <Provider store={store} key="provider">
          <MediaQueryProvider>
            <ThemeProvider theme={styledTheme}>
              <div>
                {isPage && (
                  <StickyContainer>
                    <GlobalStyle />
                    <Notifier />
                    <AuthModal />
                    {children}
                  </StickyContainer>
                )}
                {!isPage && children}
              </div>
            </ThemeProvider>
          </MediaQueryProvider>
        </Provider>
      </TouchDeviceContext.Provider>
    )
  }

  render() {
    const { serverSide } = this.props
    let styleTags = null
    const renderedComponent = this.renderProvidedComponent()
    if (serverSide) {
      const sheet = new ServerStyleSheet()
      renderToString(sheet.collectStyles(renderedComponent))
      styleTags = sheet.getStyleElement()
    }

    return (
      <div>
        <div key="static-component-styles">{styleTags}</div>
        <div key="static">{renderedComponent}</div>
      </div>
    )
  }
}

export default StaticWrapper
